var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "cart-container" }, [
        _vm.count >= 1
          ? _c(
              "div",
              { staticClass: "cart" },
              [
                _c("p", { staticClass: "cart__heading" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        "Yhteensä " +
                          _vm.count +
                          (_vm.count == 1 ? " tuote" : " tuotetta")
                      ) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "Container",
                  {
                    attrs: {
                      "drag-handle-selector": ".js-handle",
                      "drag-class": "state-dragging",
                      role: "list"
                    },
                    on: { drop: _vm.onDrop }
                  },
                  _vm._l(_vm.cartContents, function(cart_item, index) {
                    return _c(
                      "Draggable",
                      {
                        key: cart_item.key,
                        staticClass: "cart__line-item-container"
                      },
                      [
                        _c("CartItem", {
                          key: cart_item.key,
                          ref: "cart-item-" + cart_item.key,
                          refInFor: true,
                          attrs: {
                            "original-cart-item": cart_item,
                            "order-type": "offer",
                            "is-last-item":
                              _vm.cartContents.length === parseInt(index) + 1,
                            "is-first-item": index === 0
                          },
                          on: {
                            remove: function($event) {
                              return _vm.removeItem(cart_item)
                            },
                            update: function($event) {
                              return _vm.updateCartItem(cart_item, $event)
                            },
                            moveUp: function($event) {
                              return _vm.moveUp(cart_item)
                            },
                            moveDown: function($event) {
                              return _vm.moveDown(cart_item)
                            },
                            editCartItem: function($event) {
                              return _vm.editCartItem(cart_item)
                            },
                            duplicate: function($event) {
                              return _vm.duplicateCartItem($event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.count === 0
          ? _c("div", { staticClass: "cart__empty-container empty-cart" }, [
              _c("p", { staticClass: "empty-cart__text" }, [
                _vm._v("\n        Ei tuotteita\n      ")
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("CartModal", {
        ref: "cartmodal",
        attrs: {
          display: _vm.displayModal,
          "default-product": _vm.selectedProduct,
          nonce: _vm.nonce
        },
        on: {
          confirm: _vm.saveProductFromModal,
          cancel: _vm.closeModal,
          remove: _vm.handleModalItemRemove
        }
      }),
      _vm._v(" "),
      _vm.$store.getters.changesAllowed
        ? _c(
            "div",
            { staticClass: "cart-footer cart-footer--search" },
            [_c("cart-product-search", { attrs: { nonce: _vm.nonce } })],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cart__items-heading" }, [
      _c(
        "span",
        {
          staticClass:
            "cart__column cart__column--heading cart__column--heading--product cart__column--product cart__column--product--offer"
        },
        [_vm._v("Tuote")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "cart__column cart__column--heading cart__column--price"
        },
        [_vm._v("Kust.hinta")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "cart__column cart__column--heading cart__column--price"
        },
        [_vm._v("Hinta / kpl")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "cart__column cart__column--heading cart__column--profit"
        },
        [_vm._v("Kate")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "cart__column cart__column--heading cart__column--amount"
        },
        [_vm._v("Määrä")]
      ),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "cart__column cart__column--heading cart__column--sum" },
        [_vm._v("Yhteensä")]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cab99f8", { render: render, staticRenderFns: staticRenderFns })
  }
}